<div class="wrap-select-group">
  <div class="item" *ngFor="let item of items">
    <button type="button" class="btn btn-white-green" [ngClass]="{'active': (item.value==selected), 'error': isError && !selected}" (click)="select(item.value)">
      {{ item.label }}
    </button>
  </div>
</div>
